import React, { useEffect, useState } from 'react';
import Placeholder from '../Placeholder';
import { apiFetch } from '../../utils';
import './styles/SchoolExplorer.scss';


const PageWidget = ({activeSchool}) => {
  const [pageSnippet, setPageSnippet] = useState(null);
  const defaultPageSnippet = "<p></p>";

  useEffect(() => {
    apiFetch.get({}, `web_snippets/shared_portal_page/rendered/?school_id=${activeSchool.id}`)
    .then((response) => {
      setPageSnippet(response.body == "" ? defaultPageSnippet : response.body);
    })
    .catch(() => {
      setPageSnippet(defaultPageSnippet);
    });
  }, [activeSchool]);

  if (activeSchool && pageSnippet) {
    return (
      <div className='shared-portal-page-widget' id={activeSchool.id} dangerouslySetInnerHTML={{ __html: pageSnippet }} />
    );
  }

  return <Placeholder.loading ready={activeSchool && pageSnippet}>Loading Page Widget...</Placeholder.loading>;
};

export default PageWidget;
